import React from 'react';
import { SongCardSkeleton } from '@components/SongCards/ReleaseInfoCard';
import { GRID_STYLE } from '@utils/constants';

const GRID_INITIAL_PAGE_SIZE = 10;

export const GridSkeleton = ({ limit = GRID_INITIAL_PAGE_SIZE }: { limit?: number }) => (
  <div className={GRID_STYLE}>
    {[...Array(limit)].map((_, i) => (
      <div key={`recent-drops-card-${i}-skeleton`}>
        <SongCardSkeleton />
      </div>
    ))}
  </div>
);
